import { Dropdown } from 'react-bootstrap';
import { Props } from './actionDropdown.type';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import ConfirmationDialog from 'components/base/ConfirmationDialog';
import { useDeleteCandidateMutation } from 'service/institutionQuery/institutionQuery';
import CanAccess from 'components/modules/auth/Access/CanAccess';

const ActionDropdown = ({ isCanEdit, isCanRemove, id }: Props) => {
  const [deleteCandidate, { isLoading }] = useDeleteCandidateMutation();

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleView = () => {
    navigate(`/hub/students/view/${id}`);
  };
  const handleEdit = () => {
    navigate(`/hub/students/edit/${id}`);
  };
  const handleRemove = () => {
    deleteCandidate(id)
      .unwrap()
      .then(() => {
        setIsRemove(false);
      })
      .catch(console.error);
  };

  return (
    <>
      <ConfirmationDialog
        show={isRemove}
        onConfirm={handleRemove}
        onHide={() => setIsRemove(false)}
        title="Delete"
        isLoading={isLoading}
      >
        <h5>Are you sure want to remove this ?</h5>
        <p className="text-body-tertiary text-opacity-85">
          This action is irreversible and cannot be undone.
        </p>
      </ConfirmationDialog>
      <Dropdown.Item eventKey="view" onClick={handleView}>
        View
      </Dropdown.Item>
      <CanAccess action="canUpdate" entity="student">
        <Dropdown.Item
          eventKey="edit"
          disabled={!isCanEdit}
          onClick={handleEdit}
        >
          Edit
        </Dropdown.Item>
      </CanAccess>
      <CanAccess action="canDelete" entity="student">
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            eventKey="remove"
            disabled={!isCanRemove}
            className={isCanRemove ? 'text-danger' : ''}
            onClick={() => setIsRemove(true)}
          >
            Remove
          </Dropdown.Item>
        </>
      </CanAccess>
    </>
  );
};

export default ActionDropdown;
